import logService from '../../../../services/wss/logService3';
import groupNodeCache from '../Engines/GroupNodeCache';

const _name = 'OnNoteDeletedHandler';

/**
 * Handles the OnNoteDeleted SignalR event.
 * Removes entry from all nodes in cache.
 * Only dependency is GroupNodeCache — fully testable in isolation.
 */
export default class OnNoteDeletedHandler {
    // constructor(cache) {
    //     this._cache = cache;
    // }

    /**
     * @param {string} rk - row key of the deleted entry
     */
    handle = (rk) => {
        try {
            if (!rk) return false;
            groupNodeCache.removeFromAllNodes(rk);
            return true;
        } catch (error) {
            logService.logError(`${_name}.handle: ${error.message}`);
            return false;
        }
    };
}
